(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
(function() {
  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function initTymoSlider(container) {
    var scope = container || document;
    var sliders = [];

    if (scope.matches && scope.matches('.tymo-media-slider')) {
      sliders = [scope];
    } else {
      sliders = toArray(scope.querySelectorAll('.tymo-media-slider'));
    }

    sliders.forEach(function(slider) {
      if (slider.dataset.initialized) return;
      slider.dataset.initialized = 'true';

      var track = slider.querySelector('.tymo-slider__track');
      var thumbs = toArray(slider.querySelectorAll('.tymo-slider__thumb'));
      var dots = toArray(slider.querySelectorAll('.tymo-slider__dot'));
      var prevBtn = slider.querySelector('.tymo-slider__arrow--prev');
      var nextBtn = slider.querySelector('.tymo-slider__arrow--next');
      var slides = toArray(slider.querySelectorAll('.tymo-slider__slide'));
      var total = slides.length;
      var current = 0;

      if (!track || total === 0) return;

      function goTo(index) {
        if (index < 0) index = total - 1;
        if (index >= total) index = 0;

        current = index;

        slides.forEach(function(slide) {
          slide.classList.remove('tymo-slider__slide--active');
        });

        if (slides[current]) {
          slides[current].classList.add('tymo-slider__slide--active');
        }

        thumbs.forEach(function(thumb) {
          thumb.classList.remove('tymo-slider__thumb--active');
        });

        dots.forEach(function(dot) {
          dot.classList.remove('tymo-slider__dot--active');
        });

        if (thumbs[current]) thumbs[current].classList.add('tymo-slider__thumb--active');
        if (dots[current]) dots[current].classList.add('tymo-slider__dot--active');
      }

      function goToMedia(mediaId) {
        if (!mediaId) return false;
        var mediaIdString = String(mediaId);
        var targetIndex = -1;

        slides.forEach(function(slide, index) {
          if (String(slide.dataset.mediaId) === mediaIdString) {
            targetIndex = index;
          }
        });

        if (targetIndex >= 0) {
          goTo(targetIndex);
          return true;
        }

        return false;
      }

      slider.tymoGoToSlide = goTo;
      slider.tymoGoToMedia = goToMedia;

      function goToWithLock(index) {
        if (slider.dataset.slideLocked === 'true') return;

        slider.dataset.slideLocked = 'true';
        goTo(index);

        window.setTimeout(function() {
          slider.dataset.slideLocked = 'false';
        }, 430);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function(event) {
          event.preventDefault();
          goToWithLock(current - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function(event) {
          event.preventDefault();
          goToWithLock(current + 1);
        });
      }

      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function(event) {
          event.preventDefault();
          var index = parseInt(this.dataset.thumb, 10);
          if (!isNaN(index)) goToWithLock(index);
        });
      });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function(event) {
          event.preventDefault();
          var index = parseInt(this.dataset.dot, 10);
          if (!isNaN(index)) goToWithLock(index);
        });
      });

      var startX = 0;
      var currentX = 0;
      var isDragging = false;
      var dragStarted = false;

      function getClientX(event) {
        if (event.touches && event.touches.length) {
          return event.touches[0].clientX;
        }

        if (event.changedTouches && event.changedTouches.length) {
          return event.changedTouches[0].clientX;
        }

        return event.clientX;
      }

      function startDrag(event) {
        if (total <= 1) return;

        startX = getClientX(event);
        currentX = startX;
        isDragging = true;
        dragStarted = false;

        track.classList.add('is-dragging');
      }

      function moveDrag(event) {
        if (!isDragging) return;

        currentX = getClientX(event);

        var diff = currentX - startX;

        if (Math.abs(diff) > 6) {
          dragStarted = true;
        }
      }

      function endDrag(event) {
        if (!isDragging) return;

        var endX = getClientX(event);
        var diff = startX - endX;

        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            goToWithLock(current + 1);
          } else {
            goToWithLock(current - 1);
          }
        }

        isDragging = false;
        dragStarted = false;
        track.classList.remove('is-dragging');
      }

      function cancelDrag() {
        isDragging = false;
        dragStarted = false;
        track.classList.remove('is-dragging');
      }

      track.addEventListener('touchstart', startDrag, { passive: true });
      track.addEventListener('touchmove', moveDrag, { passive: true });
      track.addEventListener('touchend', endDrag, { passive: true });
      track.addEventListener('touchcancel', cancelDrag, { passive: true });

      track.addEventListener('mousedown', function(event) {
        if (event.button !== 0) return;
        startDrag(event);
      });

      window.addEventListener('mousemove', function(event) {
        moveDrag(event);
      });

      window.addEventListener('mouseup', function(event) {
        endDrag(event);
      });

      track.addEventListener('mouseleave', function() {
        if (!isDragging) return;
        cancelDrag();
      });

      track.addEventListener('dragstart', function(event) {
        event.preventDefault();
      });

      track.addEventListener('click', function(event) {
        if (dragStarted) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);

      goTo(0);
    });
  }

  function initTymoProductSections(container) {
    var scope = container || document;
    var roots = [];

    if (scope.matches && scope.matches('[data-tymo-product-info]')) {
      roots = [scope];
    } else {
      roots = toArray(scope.querySelectorAll('[data-tymo-product-info]'));
    }

    roots.forEach(function(root) {
      if (root.dataset.productInfoInitialized) return;
      root.dataset.productInfoInitialized = 'true';

      var jsonEl = root.querySelector('.tymo-product-json');
      if (!jsonEl) return;

      var data;
      try {
        data = JSON.parse(jsonEl.textContent);
      } catch (error) {
        return;
      }

      var variants = data.variants || [];
      var optionCount = data.option_count || 0;
      var optionInputs = toArray(root.querySelectorAll('[data-tymo-option-input]'));
      var nativeSelect = root.querySelector('.product-single__variants');
      var variantInput = root.querySelector('.tymo-variant-input');
      var quantityInput = root.querySelector('.tymo-qty__input');
      var hiddenQuantityInput = root.querySelector('.tymo-quantity-input');
      var minusButton = root.querySelector('.tymo-qty__btn--minus');
      var plusButton = root.querySelector('.tymo-qty__btn--plus');
      var addButton = root.querySelector('[data-add-to-cart-button]');
      var addButtonLabel = root.querySelector('[data-add-to-cart-label]');
      var currentPrice = root.querySelector('[data-price-current]');
      var comparePrice = root.querySelector('[data-price-compare]');
      var comparePriceText = root.querySelector('[data-price-compare-text]');
      var autoDiscountOffer = root.querySelector('[data-auto-discount-offer]');
      var autoDiscountLabel = autoDiscountOffer ? autoDiscountOffer.querySelector('.tymo-auto-discount-offer__label') : null;
      var inventoryBadge = root.querySelector('[data-inventory-badge]');
      var saleBadge = root.querySelector('[data-sale-badge]');
      var saleBadgeText = root.querySelector('[data-sale-badge-text]');
      var slider = root.querySelector('.tymo-media-slider');
      var productId = root.dataset.productId;
      var sticky = document.querySelector('sticky-add-to-cart[data-product-id="' + productId + '"]');
      var textAddToCart = root.dataset.textAddToCart || 'Add to cart';
      var textSoldOut = root.dataset.textSoldOut || 'Sold out';
      var textUnavailable = root.dataset.textUnavailable || 'Unavailable';
      var textPreorder = root.dataset.textPreorder || 'Pre-Order';
      var dynamicCheckout = root.querySelector('[data-dynamic-checkout]');
      var preorderMessage = root.querySelector('[data-preorder-message]');
      var preorderDays = root.querySelector('[data-preorder-days]');
      var deliveryEstimateLabel = root.querySelector('[data-delivery-estimate-label]');
      var deliveryEstimateDate = root.querySelector('.tymo-delivery-date');
      var normalDeliveryEstimate = deliveryEstimateDate ? deliveryEstimateDate.dataset.normalDelivery : '';
      var productForm = root.querySelector('.tymo-product-form');
      var isAddingToCart = false;

      function selectedOptions() {
        var options = [];

        for (var i = 0; i < optionCount; i++) {
          var checked = root.querySelector('[name="option-' + i + '"]:checked');
          options.push(checked ? checked.value : null);
        }

        return options;
      }

      function findVariant(options) {
        return variants.find(function(variant) {
          if (!variant || !variant.options) return false;

          for (var i = 0; i < options.length; i++) {
            if (options[i] !== null && variant.options[i] !== options[i]) {
              return false;
            }
          }

          return true;
        });
      }

      function refreshActiveStates() {
        optionInputs.forEach(function(input) {
          var item = input.closest('.tymo-version-image-item, .tymo-swatch-item, .tymo-option-item');
          if (!item) return;

          item.classList.toggle('tymo-version-image-item--active', input.checked && item.classList.contains('tymo-version-image-item'));
          item.classList.toggle('tymo-swatch-item--active', input.checked && item.classList.contains('tymo-swatch-item'));
          item.classList.toggle('tymo-option-item--active', input.checked && item.classList.contains('tymo-option-item'));
        });
      }

      function setQuantityBounds(variant) {
        var min = variant && variant.quantity_rule_min ? parseInt(variant.quantity_rule_min, 10) : 1;
        var max = variant && variant.quantity_rule_max ? parseInt(variant.quantity_rule_max, 10) : null;

        if (!quantityInput) {
          if (hiddenQuantityInput) hiddenQuantityInput.value = min;
          return;
        }

        quantityInput.min = min;

        if (max) {
          quantityInput.max = max;
        } else {
          quantityInput.removeAttribute('max');
        }

        var value = parseInt(quantityInput.value, 10);
        if (isNaN(value) || value < min) value = min;
        if (max && value > max) value = max;

        quantityInput.value = value;
        if (hiddenQuantityInput) hiddenQuantityInput.value = value;
      }

      function updateQuantity(delta) {
        if (!quantityInput) return;

        var min = parseInt(quantityInput.min || '1', 10);
        var max = quantityInput.max ? parseInt(quantityInput.max, 10) : null;
        var value = parseInt(quantityInput.value || min, 10);

        if (isNaN(value)) value = min;
        value += delta;
        if (value < min) value = min;
        if (max && value > max) value = max;

        quantityInput.value = value;
        if (hiddenQuantityInput) hiddenQuantityInput.value = value;
      }

      function updatePrices(variant) {
        if (!variant) return;

        if (currentPrice) {
          currentPrice.textContent = variant.display_price_formatted || variant.price_formatted;
        }

        if (autoDiscountOffer) {
          var discountType = variant.auto_discount_type || '';
          var discountAmount = Number(variant.auto_discount_amount || 0);
          var discountDisplay = Number(variant.auto_discount_display || 0);
          var discountPercentage = Number(variant.auto_discount_percentage || 0);
          var discountPercentageDisplay = Number(variant.auto_discount_percentage_display || 0);
          var hasPercentageDiscount =
            discountType === 'percentage' &&
            discountPercentage > 0;
          var hasAmountDiscount =
            discountType === 'amount' &&
            discountAmount > 0;
          var hasDiscount =
            hasPercentageDiscount ||
            hasAmountDiscount;

          autoDiscountOffer.classList.toggle('is-hidden', !hasDiscount);

          if (autoDiscountLabel && hasDiscount) {
            if (hasPercentageDiscount) {
              autoDiscountLabel.textContent =
                discountPercentageDisplay + '% OFF Applied';
            } else {
              autoDiscountLabel.textContent =
                'RM' + discountDisplay + ' OFF Applied';
            }
          }
        }

        if (comparePrice && comparePriceText) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceText.textContent = variant.compare_at_price_formatted || '';
            comparePrice.classList.remove('is-hidden');
          } else {
            comparePriceText.textContent = '';
            comparePrice.classList.add('is-hidden');
          }
        }
      }

      function updateSaleBadge(variant) {
        if (!saleBadge || !saleBadgeText || !variant) return;

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var savings = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          saleBadgeText.textContent = savings > 0 ? 'SAVE ' + savings + '%' : 'On Sale';
          saleBadge.classList.remove('is-hidden');
        } else {
          saleBadgeText.textContent = '';
          saleBadge.classList.add('is-hidden');
        }
      }

      function updateInventory(variant) {
        if (!inventoryBadge || !variant) return;

        if (variant.inventory_management === 'shopify' && variant.inventory_quantity > 0) {
          inventoryBadge.textContent = 'Only ' + variant.inventory_quantity + ' Left';
          inventoryBadge.style.display = '';
        } else if (variant.inventory_management === 'shopify' && !variant.available) {
          inventoryBadge.textContent = textSoldOut;
          inventoryBadge.style.display = '';
        } else {
          inventoryBadge.textContent = '';
          inventoryBadge.style.display = 'none';
        }
      }

      function preorderDaysText(variant) {
        if (!variant || !variant.is_preorder) return '';

        var min = variant.preorder_days_min;
        var max = variant.preorder_days_max;

        if (min !== null && min !== undefined && min !== '' && max !== null && max !== undefined && max !== '') {
          if (String(min) === String(max)) {
            return 'ship it out ' + min + ' working days';
          }

          if (Number(min) > Number(max)) {
            return 'ship it out ' + min + ' working days';
          }

          return 'ship it out ' + min + ' - ' + max + ' working days';
        }

        return 'ship it out 30 working days';
      }

      // Pre-order working days count from the following day (Monday-Friday).
      // Malaysia public holidays are not excluded by the preorder metafields.
      function workingDate(startDate, workingDays) {
        var result = new Date(startDate.getTime());
        while (workingDays > 0) {
          result.setUTCDate(result.getUTCDate() + 1);
          var weekday = result.getUTCDay();
          if (weekday !== 0 && weekday !== 6) workingDays--;
        }
        return result;
      }

      function malaysiaToday() {
        // Use the store's Malaysia calendar date even when the shopper is abroad.
        try {
          var parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Asia/Kuala_Lumpur', year: 'numeric', month: '2-digit', day: '2-digit'
          }).formatToParts(new Date());
          var fields = {};
          parts.forEach(function(part) { fields[part.type] = part.value; });
          return new Date(Date.UTC(Number(fields.year), Number(fields.month) - 1, Number(fields.day)));
        } catch (error) {
          var now = new Date();
          return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
        }
      }

      function preorderWorkingDays(variant) {
        var min = Number(variant.preorder_days_min);
        var max = Number(variant.preorder_days_max);
        // Match the preorder disclaimer: missing values fall back to 30 days.
        if (variant.preorder_days_min === null || variant.preorder_days_max === null ||
            variant.preorder_days_min === '' || variant.preorder_days_max === '' ||
            !Number.isInteger(min) || !Number.isInteger(max) || min < 0 || max < 0) {
          return [30, 30];
        }
        return [min, Math.max(min, max)];
      }

      function formatEstimateDate(date) {
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months[date.getUTCMonth()] + ' ' + date.getUTCDate();
      }

      function updateDeliveryEstimate(variant) {
        if (!deliveryEstimateDate || !deliveryEstimateLabel) return;
        if (!variant || !variant.is_preorder) {
          deliveryEstimateLabel.textContent = 'Est. delivery';
          deliveryEstimateDate.textContent = normalDeliveryEstimate;
          return;
        }

        var days = preorderWorkingDays(variant);
        var today = malaysiaToday();
        var earliest = workingDate(today, days[0]);
        var latest = workingDate(today, days[1]);
        deliveryEstimateLabel.textContent = 'Est. ships out';
        deliveryEstimateDate.textContent = formatEstimateDate(earliest) +
          (earliest.getTime() === latest.getTime() ? '' : '-' + formatEstimateDate(latest));
      }

      function updatePreorderMessage(variant) {
        var isPreorder = !!(variant && variant.is_preorder);

        if (preorderMessage) {
          preorderMessage.classList.toggle('is-hidden', !isPreorder);
        }

        if (preorderDays && isPreorder) {
          preorderDays.textContent = preorderDaysText(variant);
        }

        if (dynamicCheckout) {
          dynamicCheckout.classList.toggle('is-hidden', isPreorder);
        }
      }

      function updateButtons(variant) {
        var isPreorder = !!(variant && variant.is_preorder);
        var canPurchase = !!(variant && (variant.available || isPreorder));
        var label = variant ? (isPreorder ? textPreorder : (variant.available ? textAddToCart : textSoldOut)) : textUnavailable;

        if (addButton) {
          addButton.disabled = !canPurchase;
          addButton.classList.toggle('tymo-btn--disabled', !canPurchase);
          addButton.setAttribute('aria-label', label);
        }

        if (addButtonLabel) {
          addButtonLabel.textContent = label;
        }

        updatePreorderMessage(variant);
        updateDeliveryEstimate(variant);
      }

      function updateSticky(variant) {
        if (!sticky || !variant) return;

        var isPreorder = !!variant.is_preorder;
        var canPurchase = !!(variant.available || isPreorder);

        sticky.setAttribute('data-variant-available', canPurchase ? 'true' : 'false');
        sticky.setAttribute('data-current-variant-id', variant.id);

        var stickyPrice = sticky.querySelector('[data-sticky-price-display]');
        var stickyVariantTitle = sticky.querySelector('[data-sticky-variant-title]');
        var stickyButton = sticky.querySelector('.sticky-add-to-cart__button');
        var stickyLabel = sticky.querySelector('[data-sticky-add-to-cart-label] > span:first-child');
        var stickyImage = sticky.querySelector('.sticky-add-to-cart__image-img');

        if (stickyPrice) stickyPrice.textContent = variant.display_price_formatted || variant.price_formatted;
        if (stickyVariantTitle) stickyVariantTitle.textContent = variant.title;
        if (stickyButton) stickyButton.disabled = !canPurchase;
        if (stickyLabel) stickyLabel.textContent = isPreorder ? textPreorder : (variant.available ? textAddToCart : textSoldOut);

        if (stickyImage && variant.featured_image_thumb) {
          stickyImage.src = variant.featured_image_thumb;
          stickyImage.removeAttribute('srcset');
        }
      }

      function updateGallery(variant, changedInput) {
        var mediaId = variant && variant.featured_media_id ? variant.featured_media_id : null;

        if (!mediaId && changedInput && changedInput.dataset.mediaId) {
          mediaId = changedInput.dataset.mediaId;
        }

        if (slider && slider.tymoGoToMedia && mediaId) {
          slider.tymoGoToMedia(mediaId);
        }
      }

      function updateSelectedVariant(changedInput, skipGallery) {
        refreshActiveStates();

        var options = selectedOptions();
        var variant = findVariant(options);

        if (variantInput) variantInput.value = variant ? variant.id : '';
        if (nativeSelect && variant) nativeSelect.value = variant.id;

        setQuantityBounds(variant);
        updateButtons(variant);

        if (variant) {
          updatePrices(variant);
          updateSaleBadge(variant);
          updateInventory(variant);
          updateSticky(variant);

          if (!skipGallery) {
            updateGallery(variant, changedInput);
          } else if (slider && slider.tymoGoToMedia && variant.featured_media_id) {
            slider.tymoGoToMedia(variant.featured_media_id);
          }
        }
      }

      function getCartRoot() {
        if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
          return window.Shopify.routes.root;
        }

        return '/';
      }

      function waitForCartDrawerController() {
        var headerElement = document.querySelector('[data-tymo-custom-header]');
        var drawerOpenButton = document.querySelector('[data-tymo-cart-drawer-open]');

        if (
          drawerOpenButton &&
          (!headerElement || headerElement.dataset.ready === 'true')
        ) {
          return Promise.resolve(true);
        }

        return new Promise(function(resolve) {
          var settled = false;
          var observer = null;
          var timeoutId = null;

          function finish(isReady) {
            if (settled) return;
            settled = true;

            if (observer) observer.disconnect();
            if (timeoutId) window.clearTimeout(timeoutId);

            resolve(isReady);
          }

          function check() {
            var currentHeader = document.querySelector('[data-tymo-custom-header]');
            var currentButton = document.querySelector('[data-tymo-cart-drawer-open]');

            if (
              currentButton &&
              (!currentHeader || currentHeader.dataset.ready === 'true')
            ) {
              finish(true);
              return true;
            }

            return false;
          }

          observer = new MutationObserver(check);

          observer.observe(document.documentElement, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['data-ready']
          });

          timeoutId = window.setTimeout(function() {
            finish(check());
          }, 1800);

          check();
        });
      }

      async function openExistingCartDrawer() {
        await waitForCartDrawerController();

        var drawerOpenButton = document.querySelector('[data-tymo-cart-drawer-open]');
        var cartDrawer = document.querySelector('[data-tymo-cart-drawer]');
        var overlay = document.querySelector('[data-tymo-header-overlay]');

        if (drawerOpenButton) {
          drawerOpenButton.click();

          await new Promise(function(resolve) {
            window.setTimeout(resolve, 0);
          });

          if (cartDrawer && cartDrawer.classList.contains('is-open')) {
            return true;
          }
        }

        document.dispatchEvent(new CustomEvent('tymo:open-cart-drawer'));
        document.dispatchEvent(new CustomEvent('tymo:openCartDrawer'));

        await new Promise(function(resolve) {
          window.setTimeout(resolve, 0);
        });

        cartDrawer = document.querySelector('[data-tymo-cart-drawer]');
        overlay = document.querySelector('[data-tymo-header-overlay]');

        if (cartDrawer) {
          cartDrawer.classList.add('is-open');
          cartDrawer.setAttribute('aria-hidden', 'false');

          if (overlay) {
            overlay.classList.add('is-active');
          }

          document.body.classList.add('tymo-header-drawer-open');
          return true;
        }

        return false;
      }

      function updateHeaderCartCount(cart) {
        if (!cart) return;

        var count = Number(cart.item_count || 0);
        var headerCounts = toArray(document.querySelectorAll('[data-tymo-cart-count]'));
        var drawerCounts = toArray(document.querySelectorAll('[data-tymo-cart-drawer-count]'));

        headerCounts.forEach(function(element) {
          element.textContent = count;
        });

        drawerCounts.forEach(function(element) {
          element.textContent = count + (count === 1 ? ' item' : ' items');
        });
      }

      function getCurrentQuantity() {
        var qty = hiddenQuantityInput ? parseInt(hiddenQuantityInput.value, 10) : NaN;

        if (isNaN(qty) && quantityInput) {
          qty = parseInt(quantityInput.value, 10);
        }

        return isNaN(qty) || qty < 1 ? 1 : qty;
      }

      async function getCart() {
        var response = await fetch(getCartRoot() + 'cart.js', {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) return null;
        return response.json();
      }

      function setAddButtonLoading(isLoading, loadingText) {
        if (!addButton) return;

        addButton.classList.toggle('is-loading', isLoading);
        addButton.toggleAttribute('aria-busy', isLoading);

        if (isLoading) {
          addButton.disabled = true;

          if (addButtonLabel && loadingText) {
            addButtonLabel.textContent = loadingText;
          }

          return;
        }

        var selected = findVariant(selectedOptions());

        if (selected) {
          updateButtons(selected);
        } else {
          addButton.disabled = true;
          addButton.classList.add('tymo-btn--disabled');

          if (addButtonLabel) {
            addButtonLabel.textContent = textUnavailable;
          }
        }
      }

      /* =========================================================
         BOGOS EARLY-CLICK READINESS GATE

         Purpose:
         - The BOGOS app loads asynchronously after Shopify renders the page.
         - A very fast Add to Cart click can otherwise reach /cart/add.js
           before BOGOS has finished installing its gift logic.
         - Normal clicks are not delayed: if BOGOS is already ready,
           this resolves immediately.
         - Early clicks are queued only while BOGOS is still starting.
         - No gift IDs or campaign rules are duplicated in theme code.
      ========================================================= */

      var bogosReadinessPromise = null;

      function getBogosStaticHost() {
        return document.querySelector(
          '[data-persistent-bogos-product-id="' + String(productId) + '"]'
        );
      }

      function getRealBogosGiftBlock() {
        var staticHost = getBogosStaticHost();
        var candidates = toArray(document.querySelectorAll('#sca-gift-thumbnail'));

        return candidates.find(function(element) {
          return !staticHost || !staticHost.contains(element);
        }) || null;
      }

      function bogosBlockHasGiftContent(element) {
        if (!element) return false;

        return !!(
          element.querySelector('.product-item') ||
          element.querySelector('.fg-gift-thumbnail-offer') ||
          element.querySelector('.fg-gift-thumbnail-offer-slider')
        );
      }

      function isBogosReadyForAdd() {
        if (root.dataset.tymoBogosReady === 'true') {
          return true;
        }

        return bogosBlockHasGiftContent(getRealBogosGiftBlock());
      }

      function hasBogosAppOnPage() {
        return !!(
          document.querySelector('#secomapp_freegifts_version') ||
          document.querySelector('.bogos-shopify-block') ||
          window.AVADA_FREE_GIFTS ||
          window.SECOMAPP
        );
      }

      function hasSavedBogosGiftSnapshot() {
        try {
          var storageKey = 'persistent-bogos-product-display-v2:' + String(productId);
          var storedValue = window.sessionStorage.getItem(storageKey);

          if (!storedValue) return false;

          var storedData = JSON.parse(storedValue);
          var savedAt = Number(storedData && storedData.savedAt ? storedData.savedAt : 0);
          var maxSnapshotAge = 30 * 60 * 1000;

          if (
            !storedData ||
            typeof storedData.html !== 'string' ||
            !storedData.html.trim() ||
            !savedAt ||
            Date.now() - savedAt > maxSnapshotAge
          ) {
            window.sessionStorage.removeItem(storageKey);
            return false;
          }

          return true;
        } catch (error) {
          return false;
        }
      }

      function waitForBogosBeforeCartAdd() {
        if (isBogosReadyForAdd()) {
          return Promise.resolve(true);
        }

        /*
          If BOGOS is not installed on this page, never add a delay.
        */
        if (!hasBogosAppOnPage()) {
          return Promise.resolve(false);
        }

        /*
          Reuse the same promise if a second trigger happens while the
          first readiness check is still running.
        */
        if (bogosReadinessPromise) {
          return bogosReadinessPromise;
        }

        var knownGiftProduct = hasSavedBogosGiftSnapshot();

        /*
          A known gift product gets a slightly longer safety window.
          On a first visit, the gate is still capped so Add to Cart can
          never hang permanently if BOGOS has no offer for this product.
        */
        var maxWait = knownGiftProduct
          ? 4000
          : (document.readyState === 'complete' ? 1200 : 3200);

        bogosReadinessPromise = new Promise(function(resolve) {
          var settled = false;
          var observer = null;
          var timeoutId = null;
          var loadSettleId = null;

          function finish(isReady) {
            if (settled) return;
            settled = true;

            if (observer) observer.disconnect();
            if (timeoutId) window.clearTimeout(timeoutId);
            if (loadSettleId) window.clearTimeout(loadSettleId);

            document.removeEventListener('tymo:bogosReady', onBogosReady);
            window.removeEventListener('load', onWindowLoad);

            resolve(isReady);
          }

          function checkReady() {
            if (isBogosReadyForAdd()) {
              root.dataset.tymoBogosReady = 'true';
              finish(true);
              return true;
            }

            return false;
          }

          function onBogosReady(event) {
            var detail = event && event.detail ? event.detail : {};

            if (
              detail.productId &&
              String(detail.productId) !== String(productId)
            ) {
              return;
            }

            checkReady();
          }

          function onWindowLoad() {
            /*
              Give deferred BOGOS DOM rendering one short frame after
              the page load event, while still respecting the hard cap.
            */
            loadSettleId = window.setTimeout(checkReady, 80);
          }

          document.addEventListener('tymo:bogosReady', onBogosReady);
          window.addEventListener('load', onWindowLoad, { once: true });

          observer = new MutationObserver(function() {
            checkReady();
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true
          });

          timeoutId = window.setTimeout(function() {
            finish(isBogosReadyForAdd());
          }, maxWait);

          checkReady();
        }).then(function(isReady) {
          bogosReadinessPromise = null;
          return isReady;
        });

        return bogosReadinessPromise;
      }

      async function addCurrentVariantToCart() {
        if (!productForm || isAddingToCart || !variantInput || !variantInput.value) return;
        if (addButton && addButton.disabled) return;

        isAddingToCart = true;
        setAddButtonLoading(true, 'Adding to cart...');

        try {
          var selectedVariantId = Number(variantInput.value);
          var selectedQuantity = getCurrentQuantity();

          if (!selectedVariantId || selectedQuantity < 1) {
            throw new Error('Please select an available product option.');
          }

          /*
            If the customer clicks immediately after refresh, hold this
            specific cart add until BOGOS is ready. Once ready, the normal
            Shopify /cart/add.js request continues unchanged.
          */
          await waitForBogosBeforeCartAdd();

          setAddButtonLoading(true, 'Adding to cart...');

          var response = await fetch(getCartRoot() + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: selectedVariantId,
              quantity: selectedQuantity
            })
          });

          var result = await response.json().catch(function() {
            return null;
          });

          if (!response.ok) {
            throw new Error(result && result.description ? result.description : 'Unable to add this product to cart.');
          }

          document.dispatchEvent(new CustomEvent('customCart:itemAdded', {
            detail: {
              item: result,
              variantId: selectedVariantId,
              quantity: selectedQuantity
            }
          }));

          var cart = await getCart();

          if (cart) {
            updateHeaderCartCount(cart);

            document.dispatchEvent(new CustomEvent('customCart:updated', {
              detail: {
                cart: cart
              }
            }));
          }

          await openExistingCartDrawer();
        } catch (error) {
          alert(error && error.message ? error.message : 'Sorry, this product could not be added. Please try again.');
        } finally {
          isAddingToCart = false;
          setAddButtonLoading(false);
        }
      }

      if (productForm) {
        productForm._tymoSubmitReady = function() {
          productForm.dataset.tymoEarlySubmitRequested = 'false';
          addCurrentVariantToCart();
        };

        if (productForm.dataset.tymoEarlySubmitRequested === 'true') {
          window.setTimeout(function() {
            if (typeof productForm._tymoSubmitReady === 'function') {
              productForm._tymoSubmitReady();
            }
          }, 0);
        }
      }

      optionInputs.forEach(function(input) {
        input.addEventListener('change', function(event) {
          updateSelectedVariant(event.currentTarget, false);
        });
      });

      if (minusButton) {
        minusButton.addEventListener('click', function() {
          updateQuantity(-1);
        });
      }

      if (plusButton) {
        plusButton.addEventListener('click', function() {
          updateQuantity(1);
        });
      }

      if (quantityInput) {
        quantityInput.addEventListener('change', function() {
          updateQuantity(0);
        });
        quantityInput.addEventListener('input', function() {
          if (hiddenQuantityInput) hiddenQuantityInput.value = quantityInput.value;
        });
      }

      updateSelectedVariant(null, true);
    });
  }

  function initTymoJudgemeRatings(container) {
    var scope = container || document;
    var ratingBlocks = [];

    if (scope.matches && scope.matches('[data-tymo-product-rating]')) {
      ratingBlocks = [scope];
    } else {
      ratingBlocks = toArray(scope.querySelectorAll('[data-tymo-product-rating]'));
    }

    function cleanNumber(value) {
      if (value === null || value === undefined) return '';
      return String(value).replace(/[^0-9.]/g, '');
    }

    function formatRating(value) {
      var number = parseFloat(value);
      if (!number || number <= 0) return '';
      if (number > 5) number = 5;
      return number.toFixed(1).replace('.0', '');
    }

    function findReviewTarget() {
      var selectors = [
        '#judgeme_product_reviews',
        '#product-reviews',
        '.jdgm-rev-widg',
        '.jdgm-widget.jdgm-review-widget',
        '[id*="judgeme"][id*="review"]',
        '[class*="jdgm-rev-widg"]'
      ];

      for (var i = 0; i < selectors.length; i++) {
        var target = document.querySelector(selectors[i]);
        if (target) return target;
      }

      return null;
    }

    ratingBlocks.forEach(function(ratingWrap) {
      var source = ratingWrap.querySelector('.jdgm-prev-badge');
      var text = ratingWrap.querySelector('[data-tymo-rating-text]');
      var reviewsLink = ratingWrap.querySelector('[data-tymo-rating-reviews]');
      var stars = toArray(ratingWrap.querySelectorAll('.tymo-judgeme-rating__star'));

      if (!text || !reviewsLink || stars.length === 0) return;

      var rating =
        cleanNumber(ratingWrap.getAttribute('data-rating-fallback')) ||
        '';

      var reviewCount =
        cleanNumber(ratingWrap.getAttribute('data-count-fallback')) ||
        '';

      if (source) {
        rating =
          cleanNumber(source.getAttribute('data-average-rating')) ||
          cleanNumber(source.getAttribute('data-rating')) ||
          rating;

        reviewCount =
          cleanNumber(source.getAttribute('data-number-of-reviews')) ||
          cleanNumber(source.getAttribute('data-review-count')) ||
          cleanNumber(source.getAttribute('data-count')) ||
          reviewCount;
      }

      if ((!rating || rating === '0' || rating === '0.0') && source) {
        var sourceText = source.textContent || '';
        var ratingMatch = sourceText.match(/([0-5](?:\.\d+)?)/);

        if (ratingMatch && ratingMatch[1]) {
          rating = ratingMatch[1];
        }
      }

      if ((!reviewCount || reviewCount === '0') && source) {
        var reviewText = source.textContent || '';
        var reviewMatch = reviewText.match(/(\d+)\s*(?:review|reviews)/i);

        if (reviewMatch && reviewMatch[1]) {
          reviewCount = reviewMatch[1];
        }
      }

      var ratingNumber = parseFloat(rating);
      var countNumber = parseInt(reviewCount, 10);

      if (!ratingNumber || ratingNumber <= 0) {
        ratingWrap.classList.add('is-hidden');
        ratingWrap.classList.remove('is-ready');
        return;
      }

      if (ratingNumber > 5) ratingNumber = 5;

      stars.forEach(function(star, index) {
        var starNumber = index + 1;

        star.classList.remove('is-full', 'is-half', 'is-empty');

        if (ratingNumber >= starNumber) {
          star.classList.add('is-full');
        } else if (ratingNumber >= starNumber - 0.5) {
          star.classList.add('is-half');
        } else {
          star.classList.add('is-empty');
        }
      });

      text.textContent = 'Rated ' + formatRating(ratingNumber) + '/5';

      if (countNumber && countNumber > 0) {
        reviewsLink.textContent = '(' + countNumber + ' ' + (countNumber === 1 ? 'review' : 'reviews') + ')';
        reviewsLink.style.display = '';
      } else {
        reviewsLink.textContent = '';
        reviewsLink.style.display = 'none';
      }

      ratingWrap.classList.remove('is-hidden');
      ratingWrap.classList.add('is-ready');
    });

    toArray(scope.querySelectorAll('[data-tymo-rating-reviews]')).forEach(function(link) {
      if (link.dataset.tymoScrollReady === 'true') return;
      link.dataset.tymoScrollReady = 'true';

      link.addEventListener('click', function(event) {
        var target = findReviewTarget();

        if (!target) return;

        event.preventDefault();

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    });
  }

  function initAll(container) {
    initTymoSlider(container);
    initTymoProductSections(container);
    initTymoJudgemeRatings(container);

    window.setTimeout(function() {
      initTymoJudgemeRatings(container);
    }, 700);

    window.setTimeout(function() {
      initTymoJudgemeRatings(container);
    }, 1600);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-product-info"]) return;
  try {
    
(function() {
  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function initTymoSlider(container) {
    var scope = container || document;
    var sliders = [];

    if (scope.matches && scope.matches('.tymo-media-slider')) {
      sliders = [scope];
    } else {
      sliders = toArray(scope.querySelectorAll('.tymo-media-slider'));
    }

    sliders.forEach(function(slider) {
      if (slider.dataset.initialized) return;
      slider.dataset.initialized = 'true';

      var track = slider.querySelector('.tymo-slider__track');
      var thumbs = toArray(slider.querySelectorAll('.tymo-slider__thumb'));
      var dots = toArray(slider.querySelectorAll('.tymo-slider__dot'));
      var prevBtn = slider.querySelector('.tymo-slider__arrow--prev');
      var nextBtn = slider.querySelector('.tymo-slider__arrow--next');
      var slides = toArray(slider.querySelectorAll('.tymo-slider__slide'));
      var total = slides.length;
      var current = 0;

      if (!track || total === 0) return;

      function goTo(index) {
        if (index < 0) index = total - 1;
        if (index >= total) index = 0;

        current = index;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
        track.style.transition = 'transform 0.4s ease';

        thumbs.forEach(function(thumb) {
          thumb.classList.remove('tymo-slider__thumb--active');
        });
        dots.forEach(function(dot) {
          dot.classList.remove('tymo-slider__dot--active');
        });

        if (thumbs[current]) thumbs[current].classList.add('tymo-slider__thumb--active');
        if (dots[current]) dots[current].classList.add('tymo-slider__dot--active');
      }

      function goToMedia(mediaId) {
        if (!mediaId) return false;
        var mediaIdString = String(mediaId);
        var targetIndex = -1;

        slides.forEach(function(slide, index) {
          if (String(slide.dataset.mediaId) === mediaIdString) {
            targetIndex = index;
          }
        });

        if (targetIndex >= 0) {
          goTo(targetIndex);
          return true;
        }

        return false;
      }

      slider.tymoGoToSlide = goTo;
      slider.tymoGoToMedia = goToMedia;

      function goToWithLock(index) {
        if (slider.dataset.slideLocked === 'true') return;

        slider.dataset.slideLocked = 'true';
        goTo(index);

        window.setTimeout(function() {
          slider.dataset.slideLocked = 'false';
        }, 430);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function(event) {
          event.preventDefault();
          goToWithLock(current - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function(event) {
          event.preventDefault();
          goToWithLock(current + 1);
        });
      }

      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function(event) {
          event.preventDefault();
          var index = parseInt(this.dataset.thumb, 10);
          if (!isNaN(index)) goToWithLock(index);
        });
      });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function(event) {
          event.preventDefault();
          var index = parseInt(this.dataset.dot, 10);
          if (!isNaN(index)) goToWithLock(index);
        });
      });

      var startX = 0;
      var isDragging = false;

      track.addEventListener('touchstart', function(event) {
        startX = event.touches[0].clientX;
        isDragging = true;
      }, { passive: true });

      track.addEventListener('touchend', function(event) {
        if (!isDragging) return;

        var endX = event.changedTouches[0].clientX;
        var diff = startX - endX;

        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            goToWithLock(current + 1);
          } else {
            goToWithLock(current - 1);
          }
        }

        isDragging = false;
      }, { passive: true });

      goTo(0);
    });
  }

  function initTymoProductSections(container) {
    var scope = container || document;
    var roots = [];

    if (scope.matches && scope.matches('[data-tymo-product-info]')) {
      roots = [scope];
    } else {
      roots = toArray(scope.querySelectorAll('[data-tymo-product-info]'));
    }

    roots.forEach(function(root) {
      if (root.dataset.productInfoInitialized) return;
      root.dataset.productInfoInitialized = 'true';

      var jsonEl = root.querySelector('.tymo-product-json');
      if (!jsonEl) return;

      var data;
      try {
        data = JSON.parse(jsonEl.textContent);
      } catch (error) {
        return;
      }

      var variants = data.variants || [];
      var optionCount = data.option_count || 0;
      var optionInputs = toArray(root.querySelectorAll('[data-tymo-option-input]'));
      var nativeSelect = root.querySelector('.product-single__variants');
      var variantInput = root.querySelector('.tymo-variant-input');
      var quantityInput = root.querySelector('.tymo-qty__input');
      var hiddenQuantityInput = root.querySelector('.tymo-quantity-input');
      var minusButton = root.querySelector('.tymo-qty__btn--minus');
      var plusButton = root.querySelector('.tymo-qty__btn--plus');
      var addButton = root.querySelector('[data-add-to-cart-button]');
      var addButtonLabel = root.querySelector('[data-add-to-cart-label]');
      var currentPrice = root.querySelector('[data-price-current]');
      var comparePrice = root.querySelector('[data-price-compare]');
      var comparePriceText = root.querySelector('[data-price-compare-text]');
      var inventoryBadge = root.querySelector('[data-inventory-badge]');
      var saleBadge = root.querySelector('[data-sale-badge]');
      var saleBadgeText = root.querySelector('[data-sale-badge-text]');
      var slider = root.querySelector('.tymo-media-slider');
      var productId = root.dataset.productId;
      var sticky = document.querySelector('sticky-add-to-cart[data-product-id="' + productId + '"]');
      var textAddToCart = root.dataset.textAddToCart || 'Add to cart';
      var textSoldOut = root.dataset.textSoldOut || 'Sold out';
      var textUnavailable = root.dataset.textUnavailable || 'Unavailable';

      function selectedOptions() {
        var options = [];

        for (var i = 0; i < optionCount; i++) {
          var checked = root.querySelector('[name="option-' + i + '"]:checked');
          options.push(checked ? checked.value : null);
        }

        return options;
      }

      function findVariant(options) {
        return variants.find(function(variant) {
          if (!variant || !variant.options) return false;

          for (var i = 0; i < options.length; i++) {
            if (options[i] !== null && variant.options[i] !== options[i]) {
              return false;
            }
          }

          return true;
        });
      }

      function refreshActiveStates() {
        optionInputs.forEach(function(input) {
          var item = input.closest('.tymo-version-image-item, .tymo-swatch-item, .tymo-option-item');
          if (!item) return;

          item.classList.toggle('tymo-version-image-item--active', input.checked && item.classList.contains('tymo-version-image-item'));
          item.classList.toggle('tymo-swatch-item--active', input.checked && item.classList.contains('tymo-swatch-item'));
          item.classList.toggle('tymo-option-item--active', input.checked && item.classList.contains('tymo-option-item'));
        });
      }

      function setQuantityBounds(variant) {
        var min = variant && variant.quantity_rule_min ? parseInt(variant.quantity_rule_min, 10) : 1;
        var max = variant && variant.quantity_rule_max ? parseInt(variant.quantity_rule_max, 10) : null;

        if (!quantityInput) {
          if (hiddenQuantityInput) hiddenQuantityInput.value = min;
          return;
        }

        quantityInput.min = min;

        if (max) {
          quantityInput.max = max;
        } else {
          quantityInput.removeAttribute('max');
        }

        var value = parseInt(quantityInput.value, 10);
        if (isNaN(value) || value < min) value = min;
        if (max && value > max) value = max;

        quantityInput.value = value;
        if (hiddenQuantityInput) hiddenQuantityInput.value = value;
      }

      function updateQuantity(delta) {
        if (!quantityInput) return;

        var min = parseInt(quantityInput.min || '1', 10);
        var max = quantityInput.max ? parseInt(quantityInput.max, 10) : null;
        var value = parseInt(quantityInput.value || min, 10);

        if (isNaN(value)) value = min;
        value += delta;
        if (value < min) value = min;
        if (max && value > max) value = max;

        quantityInput.value = value;
        if (hiddenQuantityInput) hiddenQuantityInput.value = value;
      }

      function updatePrices(variant) {
        if (!variant) return;

        if (currentPrice) currentPrice.textContent = variant.price_formatted;

        if (comparePrice && comparePriceText) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceText.textContent = variant.compare_at_price_formatted || '';
            comparePrice.classList.remove('is-hidden');
          } else {
            comparePriceText.textContent = '';
            comparePrice.classList.add('is-hidden');
          }
        }
      }

      function updateSaleBadge(variant) {
        if (!saleBadge || !saleBadgeText || !variant) return;

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var savings = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          saleBadgeText.textContent = savings > 0 ? 'SAVE ' + savings + '%' : 'On Sale';
          saleBadge.classList.remove('is-hidden');
        } else {
          saleBadgeText.textContent = '';
          saleBadge.classList.add('is-hidden');
        }
      }

      function updateInventory(variant) {
        if (!inventoryBadge || !variant) return;

        if (variant.inventory_management === 'shopify' && variant.inventory_quantity > 0) {
          inventoryBadge.textContent = 'Only ' + variant.inventory_quantity + ' Left';
          inventoryBadge.style.display = '';
        } else if (variant.inventory_management === 'shopify' && !variant.available) {
          inventoryBadge.textContent = textSoldOut;
          inventoryBadge.style.display = '';
        } else {
          inventoryBadge.textContent = '';
          inventoryBadge.style.display = 'none';
        }
      }

      function updateButtons(variant) {
        var available = !!(variant && variant.available);
        var label = variant ? (available ? textAddToCart : textSoldOut) : textUnavailable;

        if (addButton) {
          addButton.disabled = !available;
          addButton.classList.toggle('tymo-btn--disabled', !available);
        }

        if (addButtonLabel) {
          addButtonLabel.textContent = label;
        }
      }

      function updateSticky(variant) {
        if (!sticky || !variant) return;

        sticky.setAttribute('data-variant-available', variant.available ? 'true' : 'false');
        sticky.setAttribute('data-current-variant-id', variant.id);

        var stickyPrice = sticky.querySelector('[data-sticky-price-display]');
        var stickyVariantTitle = sticky.querySelector('[data-sticky-variant-title]');
        var stickyButton = sticky.querySelector('.sticky-add-to-cart__button');
        var stickyLabel = sticky.querySelector('[data-sticky-add-to-cart-label] > span:first-child');
        var stickyImage = sticky.querySelector('.sticky-add-to-cart__image-img');

        if (stickyPrice) stickyPrice.textContent = variant.price_formatted;
        if (stickyVariantTitle) stickyVariantTitle.textContent = variant.title;
        if (stickyButton) stickyButton.disabled = !variant.available;
        if (stickyLabel) stickyLabel.textContent = variant.available ? textAddToCart : textSoldOut;

        if (stickyImage && variant.featured_image_thumb) {
          stickyImage.src = variant.featured_image_thumb;
          stickyImage.removeAttribute('srcset');
        }
      }

      function updateGallery(variant, changedInput) {
        var mediaId = variant && variant.featured_media_id ? variant.featured_media_id : null;

        if (!mediaId && changedInput && changedInput.dataset.mediaId) {
          mediaId = changedInput.dataset.mediaId;
        }

        if (slider && slider.tymoGoToMedia && mediaId) {
          slider.tymoGoToMedia(mediaId);
        }
      }

      function updateSelectedVariant(changedInput, skipGallery) {
        refreshActiveStates();

        var options = selectedOptions();
        var variant = findVariant(options);

        if (variantInput) variantInput.value = variant ? variant.id : '';
        if (nativeSelect && variant) nativeSelect.value = variant.id;

        setQuantityBounds(variant);
        updateButtons(variant);

        if (variant) {
          updatePrices(variant);
          updateSaleBadge(variant);
          updateInventory(variant);
          updateSticky(variant);

          if (!skipGallery) {
            updateGallery(variant, changedInput);
          } else if (slider && slider.tymoGoToMedia && variant.featured_media_id) {
            slider.tymoGoToMedia(variant.featured_media_id);
          }
        }
      }

      optionInputs.forEach(function(input) {
        input.addEventListener('change', function(event) {
          updateSelectedVariant(event.currentTarget, false);
        });
      });

      if (minusButton) {
        minusButton.addEventListener('click', function() {
          updateQuantity(-1);
        });
      }

      if (plusButton) {
        plusButton.addEventListener('click', function() {
          updateQuantity(1);
        });
      }

      if (quantityInput) {
        quantityInput.addEventListener('change', function() {
          updateQuantity(0);
        });
        quantityInput.addEventListener('input', function() {
          if (hiddenQuantityInput) hiddenQuantityInput.value = quantityInput.value;
        });
      }

      updateSelectedVariant(null, true);
    });
  }

  function initAll(container) {
    initTymoSlider(container);
    initTymoProductSections(container);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
